const blockedShortcut = (event) => {
  const key = String(event.key || '').toLowerCase();
  const blocked =
    event.key === 'F12' ||
    (event.ctrlKey && event.shiftKey && ['i', 'j', 'c'].includes(key)) ||
    (event.ctrlKey && ['u', 's'].includes(key)) ||
    (event.metaKey && event.altKey && ['i', 'j', 'c'].includes(key));

  if (blocked) {
    event.preventDefault();
    event.stopPropagation();
  }
};

const blockContextMenu = (event) => {
  event.preventDefault();
};

export function installBrowserProtection() {
  document.addEventListener('contextmenu', blockContextMenu, true);
  document.addEventListener('keydown', blockedShortcut, true);

  return () => {
    document.removeEventListener('contextmenu', blockContextMenu, true);
    document.removeEventListener('keydown', blockedShortcut, true);
  };
}